import React from 'react';
import { LabelProps, TooltipProps } from 'recharts';
import { Box, Typography } from '@mui/material';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

export const formatPercent = (value: StringOrNumber) => `${value}%`;

export const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    const formattedLabel = new Date(label).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
    });

    return (
      <Box bgcolor="background.paper" border="1px solid" borderColor="border.default" p={1}>
        <Typography variant="subtitle2">{formattedLabel}</Typography>

        {payload.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index}>
            <Typography variant="body2">
              {entry.name}: {`${entry.value}%`}
            </Typography>
            {entry?.payload?.avgRequiredFte && (
              <Typography variant="body2">Actual Fte: {`${entry.payload.avgActualFte}%`}</Typography>
            )}
            {entry?.payload?.avgRequiredFte && (
              <Typography variant="body2">Required Fte: {`${entry.payload.avgRequiredFte}%`}</Typography>
            )}
          </Box>
        ))}
      </Box>
    );
  }
  return null;
};

export const CustomizedLabel = ({ x, y, value }: LabelProps) => {
  return (
    <text
      x={x}
      y={y}
      dy={-10}
      fill="var(--mui-palette-text-secondary)"
      fontSize={10}
      color="var(--mui-palette-text-secondary)"
      textAnchor="middle"
    >
      {value} %
    </text>
  );
};
